import React, { useState } from 'react';
import { Navbar, Nav, Container } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import logo from '../assets/images/jeevan-adhaar-logo.png';

const Header: React.FC = () => {
  const location = useLocation();
  const [expanded, setExpanded] = useState(false);

  const handleToggle = () => setExpanded(!expanded);
  const handleClose = () => setExpanded(false);

  return (
    <Navbar
      bg="white"
      expand="lg"
      sticky="top"
      expanded={expanded}
      className="shadow-sm"
      style={{ fontFamily: "'Poppins', sans-serif" }}
    >
      <Container className="d-flex align-items-center justify-content-between flex-wrap">
        {/* Logo + Title (Clickable) */}
        <Link to="/" className="d-flex align-items-center mb-2 mb-lg-0 text-decoration-none">
          <img
            src={logo}
            alt="जीवन आधार लोगो"
            style={{ height: '50px', marginRight: '10px' }}
          />
          <h4
            style={{
              margin: 0,
              fontWeight: 600,
              color: '#003366',
              fontSize: '1.5rem',
              whiteSpace: 'nowrap',
            }}
          >
            जीवन आधार
          </h4>
        </Link>

        {/* Toggler */}
        <Navbar.Toggle
          aria-controls="basic-navbar-nav"
          onClick={handleToggle}
        />

        {/* Nav Links */}
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto text-center">
            {[ 
              { to: '/', label: 'मुख्यपृष्ठ' },
              { to: '/insurance', label: 'विमा सेवा' },
              { to: '/foundation', label: 'फाउंडेशन' },
              { to: '/finance', label: 'आर्थिक सेवा' },
              { to: '/gallery', label: 'छायाचित्र' },
              { to: '/about', label: 'संस्थापकाबद्दल' },
              { to: '/contact', label: 'संपर्क' },
            ].map((item, index) => (
              <Nav.Link
                key={index}
                as={Link}
                to={item.to}
                className={`mx-2 ${
                  location.pathname === item.to ? 'fw-bold text-primary' : ''
                }`}
                onClick={handleClose}
              >
                {item.label}
              </Nav.Link>
            ))}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Header;
